module.exports = __webpack_public_path__ + "img/3_23.02.13_S3ASC_R2_01 (2).35ab1b5c.jpg";